var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.549549 4.15997e-05C0.531754 -0.000185956 0.51396 0.000520169 0.496235 0.00215724C0.218391 0.0178843 0.00070281 0.254553 5.95768e-06 0.541653V25.4558C-0.000897711 25.6519 0.101058 25.8333 0.266548 25.9298C0.432038 26.0264 0.635197 26.0231 0.797663 25.9212L2.83384 24.6497C2.87495 24.6309 2.91354 24.6067 2.94867 24.5778L20.7453 13.4642C20.9033 13.3662 21 13.19 21 12.9998C21 12.8096 20.9033 12.6333 20.7453 12.5354L2.95688 1.42812C2.95348 1.42596 2.95006 1.42385 2.94662 1.42177C2.90931 1.38995 2.8679 1.36361 2.82359 1.34349L0.797663 0.0783213C0.722609 0.0312209 0.637299 0.00430578 0.549549 4.15997e-05Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.120bbf4e.svg";
export { ForwardRef as ReactComponent };